import { CatalogCompany } from '@/shared/types/catalog';
import Image from 'next/image';
import RequestQuote from '../RequestQuote';
import './index.less';

interface ProfileTabProps {
  supplier: CatalogCompany;
}

const ProfileTab = ({ supplier }: ProfileTabProps) => {
  return (
    <div className="profile-tab-box">
      <div className="supplier-box">
        {supplier?.avatarUrl && (
          <Image
            className="supplier-avatar"
            src={supplier.avatarUrl}
            width={32}
            height={32}
            alt={supplier?.name}
            loading="lazy"
          />
        )}
        {supplier?.name && <p className="supplier-name">{supplier.name}</p>}
      </div>

      <RequestQuote supplier={supplier} />
    </div>
  );
};

export default ProfileTab;
